import { OfferIdsDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

export const getFullRoomId = (offer: Offer) => {
	return `${offer.IDs.integrationName}--${offer.IDs.integrationHotelId}--${offer.IDs.integrationRoomId}`
}

export const getFullRoomIdByIds = (offerIds: OfferIdsDto) => {
	return `${offerIds.integrationName}--${offerIds.integrationHotelId}--${offerIds.integrationRoomId}`
}
